import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons'

class Productos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            pagina: [],
            pacientes: []
        }
    }
    resetForm() {
        document.getElementById('bnombre').value = "";
        document.getElementById('btipo').value = "";
        document.getElementById('bnombre').focus();
        this.BuscarPaciente(1);
    }
    enviarPaciente = (id,cod, nombre, precio, stock) => {
       
        document.getElementById('cod_e').value = cod;
        document.getElementById('nombre_e').value = nombre;
        document.getElementById('pre_e').value = precio ;
        document.getElementById('stock_e').value = stock ;
        //this.props.agregarPaciente(sidp, snombre + " " + sapellido);
        window.$('#asignarPaciente').modal('hide');
    }
    componentDidMount() {
        this.BuscarPaciente(1);
    }
    BuscarPaciente(page) {
        let btipo = document.getElementById('buscar').value;
        let bname = document.getElementById('bnombre').value;
        console.log("Formulario Enviado...");
        if (btipo == '') {
        btipo = 0;
        }
        if (bname == '') {
        bname = 0;
        }
        fetch(Api + "SearchVentas/" + btipo + "/" + bname + "?page=" + page)
            .then((respuesta) => respuesta.json())
            .then((datosRespuesta) => {
                this.setState({ datosCargados: true, pacientes: datosRespuesta.data, pagina: datosRespuesta.total, ultimo: datosRespuesta.last_page, actual: datosRespuesta.current_page });
            })
            .catch(console.log);
    }
    render() {
        const { datosCargados, pacientes, pagina, ultimo, actual } = this.state;
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }
        return (
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="nuevaEnfermedad1Label">Equipos</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="card">
                            <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                                <h5 style={{ fontSize: 18 }} >Lista de Equipos</h5>
                            </div>
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-xl-5">
                                        <input type="text" id="buscar" name="buscar" placeholder="Nombre Paciente" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <input type="text" id="bnombre" name="bnombre" placeholder="Documento" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-4">
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => this.BuscarPaciente(1)}><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar</button>&nbsp;&nbsp;
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetForm()} ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</button>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                            <th>CÓDIGO</th>
                                            <th>NOMBRE DEL PRODUCTO</th>
                                            <th>TIPO</th>
                                            <th>PRECIO</th>
                                            <th>STOCK</th>
                                            <th>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {pacientes.map((itemProductoAlq) => (
                                                <tr key={itemProductoAlq.id}>
                                                   <td>{itemProductoAlq.codigo}</td>
                                                    <td>{itemProductoAlq.nombre}</td>
                                                    <td>{itemProductoAlq.tipo}</td>
                                                    <td>{itemProductoAlq.precio}</td>
                                                     <td>{itemProductoAlq.stock}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                             <button type="button" disabled={itemProductoAlq.stock==0?'disabled':''} className="btn btn-primary btn-sm" onClick={() => this.enviarPaciente(itemProductoAlq.id,itemProductoAlq.codigo, itemProductoAlq.nombre, itemProductoAlq.precio, itemProductoAlq.stock)}><FontAwesomeIcon icon={faArrowRight} /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className='col-xs-12'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                {(() => {
                                                    let p = [];
                                                    /*if (ultimo >= 86) {
                                                        var ult = 86;
                                                    } else {
                                                        ult = ultimo;
                                                    }
                                                    for (let i = 1; i <= ult; i++) {
                                                        p.push(<li className="page-item" key={i}><a className="page-link" href="#" onClick={() => this.BuscarPaciente(i)}>{i}</a></li>);
                                                    }*/
                                                    p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual)}>{actual}</a></li>);
                                                    return p;
                                                })()}
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarPaciente(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="card-footer text-muted">
                                        <b>Pagina</b> <span class="badge bg-primary">{actual}</span> <b>de</b> <span class="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span class="badge bg-success">{pagina}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Productos;